import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 0C0.976 0 0.140437 0.772625 0.0234375 1.76562L10 8L19.9766 1.76562C19.8596 0.772625 19.024 0 18 0H2ZM0 3.75195V14C0 15.105 0.895 16 2 16H18C19.105 16 20 15.105 20 14V3.75195L10.5293 9.66992C10.2053 9.87192 9.7947 9.87192 9.4707 9.66992L0 3.75195Z",
		fill: "inherit",
		fillOpacity: .88
	})]
});
const ForwardRef = forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
